import React from 'react'

const IngredientIcon = ({ size = 20, color = "#406212", ...props }) => {
  return (
    <svg 
      width={size} 
      height={size + 1} 
      viewBox="0 0 20 21" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16.25 5.97925H2.96875" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8.4375 13.7917H2.96875" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M7.65625 9.8855H2.96875" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M14.2969 9.18727L13.8782 9.59719C13.9884 9.70977 14.1393 9.7732 14.2969 9.7732C14.4545 9.7732 14.6053 9.70977 14.7155 9.59719L14.2969 9.18727ZM13.8555 13.5609C13.3527 13.1904 12.709 12.6643 12.1967 12.0793C11.6662 11.4734 11.3672 10.9062 11.3672 10.444H10.1953C10.1953 11.351 10.7413 12.196 11.315 12.8513C11.907 13.5273 12.6265 14.1109 13.1602 14.5043L13.8555 13.5609ZM11.3672 10.444C11.3672 9.57852 11.7535 9.12281 12.151 8.9742C12.5551 8.82313 13.1993 8.90376 13.8782 9.59719L14.7155 8.77731C13.8125 7.85501 12.6989 7.51823 11.7406 7.87656C10.7758 8.23733 10.1953 9.21781 10.1953 10.444H11.3672ZM15.4335 14.5043C15.9673 14.1109 16.6868 13.5273 17.2787 12.8513C17.8524 12.196 18.3984 11.351 18.3984 10.444H17.2266C17.2266 10.9062 16.9275 11.4735 16.397 12.0793C15.8848 12.6643 15.2411 13.1904 14.7383 13.5609L15.4335 14.5043ZM18.3984 10.444C18.3984 9.21781 17.818 8.23732 16.8531 7.87656C15.8948 7.51824 14.7813 7.85501 13.8782 8.77731L14.7155 9.59719C15.3945 8.90376 16.0387 8.82313 16.4427 8.9742C16.8402 9.12281 17.2266 9.57852 17.2266 10.444H18.3984Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default IngredientIcon
